import { _ as __decorate, a as __metadata, B as BaseComponent } from '../index-C155IGn1.js';
import { css, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import 'lit/directive.js';

var styles = css`.dropdown,
.dropdown-menu {
  --bsi-dropdown-animation-speed: var(--bsi-transition-instant);
  --bsi-dropdown-background: var(--bsi-color-background-inverse);
  --bsi-dropdown-border-color: transparent;
  --bsi-dropdown-border-radius: var(--bsi-radius-smooth);
  --bsi-dropdown-border-width: 0;
  --bsi-dropdown-box-shadow: var(--bsi-elevation-medium);
  --bsi-dropdown-color: var(--bsi-color-text-base);
  --bsi-dropdown-divider-bg: var(--bsi-color-border-subtle);
  --bsi-dropdown-divider-margin-y: var(--bsi-spacing-xxs);
  --bsi-dropdown-font-size: var(--bsi-label-font-size);
  --bsi-dropdown-header-color: var(--bsi-color-text-secondary);
  --bsi-dropdown-header-font-size: var(--bsi-label-font-size);
  --bsi-dropdown-header-padding-x: var(--bsi-spacing-s);
  --bsi-dropdown-header-padding-y: var(--bsi-spacing-xxs);
  --bsi-dropdown-inner-border-radius: var(--bsi-radius-smooth);
  --bsi-dropdown-item-padding-x: var(--bsi-spacing-s);
  --bsi-dropdown-item-padding-y: var(--bsi-spacing-xs);
  --bsi-dropdown-link-active-color: var(--bsi-color-text-primary-active);
  --bsi-dropdown-link-color: var(--bsi-color-text-primary);
  --bsi-dropdown-link-hover-color: var(--bsi-color-text-primary-hover);
  --bsi-dropdown-min-width: 10rem;
  --bsi-dropdown-notch-base-size: 1.125rem;
  --bsi-dropdown-notch-position-x: 20px;
  --bsi-dropdown-notch-position-y: -8px;
  --bsi-dropdown-padding-x: 0;
  --bsi-dropdown-padding-y: var(--bsi-spacing-xxs);
  --bsi-dropdown-spacer: 0.125rem;
  --bsi-dropdown-vertical-shift: 10px;
  --bsi-dropdown-zindex: 8;
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  z-index: var(--bsi-dropdown-zindex);
  display: none;
  min-width: var(--bsi-dropdown-min-width);
  margin: 0;
  padding: var(--bsi-dropdown-padding-y) var(--bsi-dropdown-padding-x);
  border: var(--bsi-dropdown-border-width) solid var(--bsi-dropdown-border-color);
  border-radius: 0 0 var(--bsi-dropdown-border-radius) var(--bsi-dropdown-border-radius);
  background-color: var(--bsi-dropdown-background);
  color: var(--bsi-dropdown-color);
  list-style: none;
  text-align: left;
  background-clip: padding-box;
  font-size: var(--bsi-dropdown-font-size);
  box-shadow: var(--bsi-dropdown-box-shadow);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bsi-dropdown-spacer);
}
.dropdown-menu.full-width {
  width: 100%;
}
.dropdown-menu.full-width .link-list li {
  display: inline-block;
  width: auto;
}
.dropdown-menu.full-width .link-list li:hover, .dropdown-menu.full-width .link-list li:focus {
  background: none;
  text-decoration: underline;
}
.dropdown-menu .link-list {
  margin-bottom: 0;
}
.dropdown-menu:before {
  position: absolute;
  top: var(--bsi-dropdown-notch-position-y);
  left: var(--bsi-dropdown-notch-position-x);
  content: "";
  width: var(--bsi-dropdown-notch-base-size);
  height: var(--bsi-dropdown-notch-base-size);
  border-radius: var(--bsi-dropdown-border-radius);
  background-color: var(--bsi-dropdown-background);
  transform: rotate(45deg);
}
.dropdown-menu[data-popper-placement=top-start] {
  border-radius: var(--bsi-dropdown-border-radius) var(--bsi-dropdown-border-radius) 0 0;
}
.dropdown-menu[data-popper-placement=top-start]:before {
  top: auto;
  bottom: var(--bsi-dropdown-notch-position-y);
}
.dropdown-menu[data-popper-placement=bottom-end]:before {
  right: calc(var(--bsi-dropdown-notch-position-x) / 2);
  left: auto;
}
.dropdown-menu.dark {
  --bsi-dropdown-text-color: var(--bsi-color-text-inverse);
  --bsi-dropdown-background: var(--bsi-color-background-primary-muted);
  --bsi-dropdown-link-color: var(--bsi-color-text-inverse);
  --bsi-dropdown-divider-bg: var(--bsi-color-border-subtle);
  --bsi-dropdown-link-active-color: var(--bsi-color-text-inverse);
  --bsi-dropdown-header-color: var(--bsi-color-text-inverse);
}
.dropdown-menu.dark:before {
  background-color: var(--bsi-dropdown-background);
}
.dropdown-menu.dark .link-list-heading {
  color: var(--bsi-color-text-inverse);
}
.dropdown-menu.dark .link-list span.divider {
  background: #2e465e;
}
.dropdown-menu.dark .link-list a span,
.dropdown-menu.dark .link-list a:hover span {
  color: var(--bsi-color-text-inverse);
}
.dropdown-menu.dark .link-list a.active span {
  text-decoration: underline;
}
.dropdown-menu.dark .link-list a.disabled span {
  color: hsla(var(--bsi-color-text-base), 0.35);
  cursor: not-allowed;
}
.dropdown-menu.show {
  display: block;
}
.dropdown-menu.show[data-popper-placement=bottom-start] {
  animation: dropdownFadeIn forwards var(--bsi-dropdown-animation-speed);
}
.dropdown-menu.show[data-popper-placement=top-start] {
  animation: dropdownFadeInTop forwards var(--bsi-dropdown-animation-speed);
}
.dropdown-menu.show[data-popper-placement=left-start] {
  animation: dropdownFadeInTop forwards var(--bsi-dropdown-animation-speed);
}
.dropdown-menu.show[data-popper-placement=left-start]:before {
  top: 20px;
  right: -6px;
  left: auto;
}
.dropdown-menu.show[data-popper-placement=right-start] {
  animation: dropdownFadeInTop forwards var(--bsi-dropdown-animation-speed);
}
.dropdown-menu.show[data-popper-placement=right-start]:before {
  top: 20px;
  left: -6px;
}

.dropdown-menu-start {
  --bsi-dropdown-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bsi-dropdown-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bsi-dropdown-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bsi-dropdown-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bsi-dropdown-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bsi-dropdown-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bsi-dropdown-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bsi-dropdown-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bsi-dropdown-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bsi-dropdown-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bsi-dropdown-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bsi-dropdown-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bsi-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bsi-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bsi-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bsi-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bsi-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item.list-item {
  width: auto;
  padding: var(--bsi-dropdown-item-padding-y) var(--bsi-dropdown-item-padding-x);
  border: 0;
  background-color: transparent;
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
}
.dropdown-item.list-item:hover, .dropdown-item.list-item:focus {
  text-decoration: none;
}

.dropdown-header.link-list-heading {
  display: block;
  margin-bottom: 0;
  padding: var(--bsi-dropdown-header-padding-y) var(--bsi-dropdown-header-padding-x);
  color: var(--bsi-dropdown-header-color);
  font-size: var(--bsi-dropdown-header-font-size);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bsi-dropdown-item-padding-y) var(--bsi-dropdown-item-padding-x);
  color: var(--bsi-dropdown-link-color);
}

@keyframes dropdownFadeIn {
  0% {
    margin-top: 0;
    opacity: 0;
  }
  100% {
    margin-top: var(--bsi-dropdown-vertical-shift);
    opacity: 1;
  }
}
@keyframes dropdownFadeInTop {
  0% {
    margin-top: 0;
    opacity: 0;
  }
  100% {
    margin-top: calc(-1 * var(--bsi-dropdown-vertical-shift));
    opacity: 1;
  }
}
.dropdown.dropup .dropdown-toggle:after,
.btn-group.dropup .dropdown-toggle:after {
  display: none;
}
.dropdown.dropup .dropdown-toggle[aria-expanded=true] .icon-expand,
.btn-group.dropup .dropdown-toggle[aria-expanded=true] .icon-expand {
  transform: scaleY(1);
}
.dropdown.dropup .dropdown-toggle .icon-expand,
.btn-group.dropup .dropdown-toggle .icon-expand {
  transform: scaleY(-1);
}
.dropdown.dropend .dropdown-toggle:after,
.btn-group.dropend .dropdown-toggle:after {
  display: none;
}
.dropdown.dropend .dropdown-toggle[aria-expanded=true] .icon-expand,
.btn-group.dropend .dropdown-toggle[aria-expanded=true] .icon-expand {
  transform: rotate(90deg);
}
.dropdown.dropend .dropdown-toggle .icon-expand,
.btn-group.dropend .dropdown-toggle .icon-expand {
  transform: rotate(-90deg);
}
.dropdown.dropstart .dropdown-toggle:before,
.btn-group.dropstart .dropdown-toggle:before {
  display: none;
}
.dropdown.dropstart .dropdown-toggle[aria-expanded=true] .icon-expand,
.btn-group.dropstart .dropdown-toggle[aria-expanded=true] .icon-expand {
  transform: rotate(-90deg);
}
.dropdown.dropstart .dropdown-toggle .icon-expand,
.btn-group.dropstart .dropdown-toggle .icon-expand {
  transform: rotate(90deg);
}

.btn-dropdown {
  --bsi-dropdown-button-color: var(--bsi-color-text-primary);
  --bsi-dropdown-button-padding: 10px;
  --bsi-dropdown-button-background: #fff;
  border-radius: 0;
  box-shadow: none;
  color: var(--bsi-dropdown-button-color);
}
@media (min-width: 992px) {
  .btn-dropdown {
    font-size: var(--bsi-label-font-size-l);
  }
}
.btn-dropdown:hover {
  --bsi-dropdown-button-color: var(--bsi-color-link-hover);
  text-decoration: underline;
}
.btn-dropdown:not(:disabled):active {
  box-shadow: none;
}

.btn-dropdown:after,
.dropdown-toggle:after {
  content: "";
  display: inline;
  width: auto;
  height: auto;
  margin: 0;
  border: none;
  vertical-align: bottom;
}
.btn-dropdown .icon-expand,
.dropdown-toggle .icon-expand {
  transition: transform var(--bsi-dropdown-animation-speed);
}
.btn-dropdown .icon.icon-xs,
.dropdown-toggle .icon.icon-xs {
  transform: translateY(-1px);
  transition: transform var(--bsi-dropdown-animation-speed);
}
.btn-dropdown[aria-expanded=true] .icon-expand,
.dropdown-toggle[aria-expanded=true] .icon-expand {
  transform: scaleY(-1);
}

:host {
  --bsi-dropdown-animation-speed: 0.3s;
  display: block;
}

:host li:focus-visible,
:host li a:focus-visible {
  outline: none;
}

a {
  color: var(--bsi-color-link);
  text-decoration: underline;
  text-decoration-skip-ink: auto;
  text-underline-offset: 2px;
}
a:hover {
  color: var(--bsi-color-link-hover);
  text-decoration: underline;
}

li span,
.list-item {
  font-size: var(--bsi-linklist-item-font-size);
  line-height: var(--bsi-linklist-item-line-height);
}

.list-item {
  position: relative;
  display: inline-block;
  padding-top: var(--bsi-linklist-item-spacing);
  padding-bottom: var(--bsi-linklist-item-spacing);
  text-decoration: none;
}
.list-item.active span, .list-item:hover:not(.disable) span {
  text-decoration: underline;
}
.list-item.active span {
  color: var(--bsi-color-text-primary-active);
}
.list-item.active .icon {
  color: var(--bsi-color-icon-primary-active);
}
.list-item:hover:not(.disabled) span {
  color: var(--bsi-color-link-hover);
}
.list-item:hover:not(.disabled) p {
  color: var(--bsi-color-text-secondary);
}
.list-item:hover:not(.disabled) .icon {
  fill: var(--bsi-icon-primary-hover);
}
.list-item:hover:not(.disabled) .icon.icon-inverse {
  fill: var(--bsi-icon-inverse);
}
.list-item.disabled {
  cursor: not-allowed;
}
.list-item.disabled:hover span {
  text-decoration: none;
}
.list-item.disabled span {
  color: var(--bsi-color-text-disabled);
}
.list-item.disabled svg {
  fill: var(--bsi-icon-disabled);
}
.list-item.disabled svg.secondary {
  fill: var(--bsi-icon-disabled);
}
.list-item.medium,
.list-item .list-item-title {
  font-weight: var(--bsi-font-weight-solid);
}
.list-item.large {
  --bsi-linklist-item-font-size: var(--bsi-label-font-size-l);
}
.list-item.avatar {
  display: flex;
  margin-bottom: var(--bsi-spacing-xxs);
}
.list-item.avatar .avatar {
  display: block;
  margin-right: var(--bsi-spacing-s);
}
.list-item.icon-right, .list-item.icon-left {
  padding-right: 0;
  padding-left: 0;
}
.list-item.icon-left .icon {
  left: 0;
  flex-shrink: 0;
  margin-right: var(--bsi-spacing-xxs);
}
.list-item.icon-left p {
  width: 100%;
}
.list-item.icon-right {
  width: 100%;
}
.list-item.icon-right .list-item-title-icon-wrapper {
  justify-content: space-between;
}
.list-item.right-icon .list-item-title-icon-wrapper {
  justify-content: space-between;
}
.list-item.right-icon .icon {
  transition: transform var(--bsi-dropdown-animation-speed);
}
.list-item.right-icon .icon.secondary {
  color: var(--bsi-icon-secondary);
}
.list-item[aria-expanded=true] .icon {
  transform: scale(-1);
}
.list-item .icon {
  display: inline-block;
  flex-shrink: 0;
}
.list-item .list-item-title-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.list-item .list-item-title-icon-wrapper .list-item-title {
  margin-right: var(--bsi-spacing-xxs);
}
.list-item > p {
  color: var(--bsi-color-text-secondary);
  font-size: var(--bsi-caption-font-size);
  line-height: var(--bsi-caption-leading);
}
.list-item > span {
  display: inline-block;
  color: var(--bsi-color-link);
}

.divider {
  display: block;
  height: var(--bsi-linklist-divider-size);
  margin: var(--bsi-spacing-xxs) 0;
  background: var(--bsi-color-border-subtle);
}

.dark a span,
.dark a:hover span {
  --bsi-color-link: var(--bsi-color-text-inverse);
  --bsi-color-link-hover: var(--bsi-color-text-inverse);
}
.dark a.active span {
  text-decoration: underline;
}
.dark li a.disabled,
.dark li a.disabled span {
  color: hsla(0, 0%, 100%, 0.35);
}

.fw {
  display: inline-block;
  width: auto;
}
.fw:hover, .fw:focus {
  background: none;
  text-decoration: underline;
}

.list-item > .dropdown-item-link {
  display: flex;
  align-items: center;
  white-space: normal;
}`;

let ItDropdownItem = class ItDropdownItem extends BaseComponent {
    constructor() {
        super(...arguments);
        this.label = '';
        this.value = '';
        this.active = false;
        this.large = false;
        this.separator = false;
        this.dark = false;
        this.fullWidth = false;
    }
    getFocusableElement() {
        if (this.separator)
            return null;
        const selector = this.href ? 'a, button' : 'li';
        return this.shadowRoot?.querySelector(selector) ?? null;
    }
    handlePress(event) {
        if (this.disabled)
            event.preventDefault();
    }
    render() {
        if (this.separator) {
            return html `<li part="li"><span class="divider" role="separator"></span></li>`;
        }
        const itemClasses = this.composeClass({
            dark: this.dark,
            fw: this.fullWidth,
            'list-item dropdown-item': !this.href,
        });
        const itemRole = this.href && this.itRole && this.itRole !== 'presentation' ? 'none' : this.itRole;
        const hrefRole = this.href && this.itRole && this.itRole !== 'presentation' ? this.itRole : undefined;
        const statusClasses = this.composeClass({
            disabled: this.disabled,
            active: this.active,
            large: this.large,
        });
        const isText = !this.itRole && !this.href;
        const linkClasses = this.composeClass('list-item', 'dropdown-item', statusClasses);
        const nonLinkClasses = this.composeClass(statusClasses, {
            'dropdown-item-text': isText,
        });
        const content = html `
      <slot name="prefix"></slot>
      <slot>${this.label}${this.active ? html `<span class="visually-hidden"> attivo</span>` : null}</slot>
      <slot name="suffix"></slot>
    `;
        return html `
      <li
        role="${ifDefined(itemRole)}"
        class=${ifDefined(itemClasses || undefined)}
        tabindex=${ifDefined(this.href ? undefined : '-1')}
        part=${ifDefined(this.href ? 'li' : 'focusable li')}
        @keydown=${this.href ? undefined : this.handlePress}
        @click=${this.href ? undefined : this.handlePress}
        aria-disabled=${ifDefined((this.disabled && !this.href) || undefined)}
      >
        ${this.href
            ? html `<a
              class=${linkClasses}
              part="focusable list-item"
              href=${this.href}
              role=${ifDefined(hrefRole)}
              aria-disabled=${ifDefined(this.disabled || undefined)}
              @keydown=${this.handlePress}
              @click=${this.handlePress}
              ><span class="dropdown-item-link" part="dropdown-item-text">${content}</span></a
            >`
            : html `<span class=${nonLinkClasses} part="dropdown-item-text">${content}</span>`}
      </li>
    `;
    }
};
ItDropdownItem.styles = styles;
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], ItDropdownItem.prototype, "label", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], ItDropdownItem.prototype, "value", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], ItDropdownItem.prototype, "href", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItDropdownItem.prototype, "active", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItDropdownItem.prototype, "large", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItDropdownItem.prototype, "separator", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItDropdownItem.prototype, "dark", void 0);
__decorate([
    property({ type: Boolean, attribute: 'full-width', reflect: true }),
    __metadata("design:type", Object)
], ItDropdownItem.prototype, "fullWidth", void 0);
__decorate([
    property({ type: String, attribute: 'it-role' }),
    __metadata("design:type", String)
], ItDropdownItem.prototype, "itRole", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Boolean)
], ItDropdownItem.prototype, "disabled", void 0);
ItDropdownItem = __decorate([
    customElement('it-dropdown-item')
], ItDropdownItem);

export { ItDropdownItem };
//# sourceMappingURL=it-dropdown-item.js.map
